// Inferences list - GET /v1/inference (workspace-scoped via X-Workspace-Id header).
const action = "INFERENCES_LIST";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';

export const fetchRequest = (params) => ({ type: REQUEST, payload: params });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
